// extracted by mini-css-extract-plugin
export var container = "image-text-overlay-module--container--568a2";
export var image = "image-text-overlay-module--image--77fa0";
export var overlayText = "image-text-overlay-module--overlayText--d3ee0";
export var textOverlay = "image-text-overlay-module--textOverlay--77111";
export var transformContainer = "image-text-overlay-module--transformContainer--8322a";